import NotificationBellFooter from './footer.connect'
export default NotificationBellFooter
